const TEXT_NEW_PARAMETER = {
  title_percentil: 'Modificar nuevo percentil',
  title_util: 'Modificar nuevo unit',
};

export default TEXT_NEW_PARAMETER;
